
<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
  export default {
      mounted() {
        var _that = this;
          this.$nextTick(() => {
            setTimeout(() =>{
              // _that.initPage();
            }, 1000);
          });
      },
      methods:{
        initPage() {
          var headerDom = document.getElementsByClassName('el-tabs__header'),
              searchFormDom = document.getElementsByClassName('main-tool-list'),
              tabGroupDom = document.getElementsByClassName('btnbar'),
              tableDom = document.getElementsByClassName('el-table'),
              contentDom = document.getElementsByClassName('el-table__body-wrapper'),
              sideMenuDom = document.getElementsByClassName('el-table__fixed-body-wrapper'),
              totalFooterDom = document.getElementsByClassName('el-table__fixed-footer-wrapper'),
              paginationDom = document.getElementsByClassName('pagination'),

              bodyHeight = document.body.offsetHeight,
              headerHeight = headerDom.length > 0 ? headerDom[0].offsetHeight + 40 : 0,
              tabGroupHeight = tabGroupDom.length > 0 ? tabGroupDom[0].offsetHeight : 0,
              searchFormHeight = searchFormDom.length > 0 ? searchFormDom[0].offsetHeight : 0,
              totalFooterHeight = totalFooterDom.length > 0 ? totalFooterDom[0].offsetHeight : 0,
              contentHeight = bodyHeight - searchFormHeight - tabGroupHeight - headerHeight - 62;

          if(tableDom.length == 0 || paginationDom.length == 0)
            return false;
          tableDom[0].style.maxHeight = contentHeight + 'px';
          contentDom[0].style.maxHeight = (contentHeight  - totalFooterHeight - 37) + 'px';


          if(sideMenuDom.length == 0)
            return false;
          for(let i = 0; i < sideMenuDom.length; i++) {
            sideMenuDom[i].style.maxHeight = (contentHeight  - totalFooterHeight - 54) + 'px';
          }

        }
      }
  }
</script>



// WEBPACK FOOTER //
// App.vue?48f45155